import * as API from '../api'
export const FETCH_AUTHOR = 'FETCH_AUTHOR'
export const FETCHING_AUTHOR = 'FETCHING_AUTHOR'
export const FETCH_AUTHOR_ERROR = 'FETCH_AUTHOR_ERROR'
export const FETCH_AUTHORS = 'FETCH_AUTHORS'
export const FETCHING_AUTHORS = 'FETCHING_AUTHORS'
export const FETCH_AUTHORS_ERROR = 'FETCH_AUTHORS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_AUTHOR = 'CHANGE_AUTHOR'
export const DELETE_AUTHOR = 'DELETE_AUTHOR'
export const ADD_AUTHOR = 'ADD_AUTHOR'
export const EDIT_AUTHOR = 'EDIT_AUTHOR'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_AUTHOR = 'NEW_FORM_AUTHOR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const AUTHOR_FORM_ERROR = 'AUTHOR_FORM_ERROR'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeAuthor = author => {
  return dispatch => {
    dispatch({ type: CHANGE_AUTHOR, author })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

const getInvalidField = errorMessage => {
  const [x, field = ''] = /validation failed: (.*):/.exec(errorMessage) || [] // eslint-disable-line
  return field
}

export const handleAuthorError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: AUTHOR_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    case errorMessage.includes('validation failed'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: AUTHOR_FORM_ERROR,
        field: getInvalidField(errorMessage),
        message: `${getInvalidField(errorMessage)} é inválido.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormAuthor = author => {
  return dispatch => {
    dispatch({ type: NEW_FORM_AUTHOR })
  }
}

export const setAuthorFormTouched = author => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreAuthor = id => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTHORS })
    return API.authors
      .restoreAuthor(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_AUTHOR, author: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_AUTHORS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleAuthorError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchAuthors = options => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTHORS })
    return API.authors
      .getAuthors(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_AUTHORS,
          authors: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_AUTHORS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteAuthor = id => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTHORS })
    return API.authors
      .deleteAuthor(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_AUTHOR, author: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_AUTHORS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const addAuthor = author => {
  author.documento = author.documento.replace(/\.|-|\//g, '')
  const data = new FormData()
  data.append('curriculo', author.curriculo)
  data.append('documento', author.documento)
  data.append('especializacao', author.especializacao)
  data.append('photo', author.avatarFile)
  data.append('email', author.email)
  data.append('nome', author.nome)
  data.append('exibirFotoPwa', !!author.exibirFotoPwa)
  data.append('removePhoto', !author.foto)

  return dispatch => {
    dispatch({ type: FETCHING_AUTHORS })
    dispatch({ type: FETCHING_AUTHOR })
    return API.authors
      .addAuthor(data)
      .then(({ data }) => {
        dispatch({ type: ADD_AUTHOR, author: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleAuthorError(response, dispatch)
        dispatch({
          type: FETCH_AUTHORS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editAuthor = author => {
  author.documento = author.documento.replace(/\.|-|\//g, '')
  const {
    curriculo = '',
    documento = '',
    especializacao = '',
    email = '',
    nome = '',
    _id = '',
    avatarFile = ''
  } = author
  const data = new FormData()
  data.append('curriculo', curriculo)
  data.append('documento', documento)
  data.append('especializacao', especializacao)
  if (avatarFile) {
    data.append('photo', avatarFile)
  }
  data.append('email', email)
  data.append('nome', nome)
  data.append('exibirFotoPwa', !!author.exibirFotoPwa)
  data.append('removePhoto', !author.foto && !avatarFile)

  return dispatch => {
    dispatch({ type: FETCHING_AUTHORS })
    dispatch({ type: FETCHING_AUTHOR })
    return API.authors
      .editAuthor(data, _id)
      .then(({ data }) => {
        dispatch({ type: EDIT_AUTHOR, author: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_AUTHORS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleAuthorError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchAuthor = id => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTHOR, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.authors
      .getAuthor(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_AUTHOR, author: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_AUTHOR_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/authors.js